"use client";
import React, { useEffect, useMemo, useRef, useState } from "react";
import { Parallax } from "react-parallax";
import Slider from "react-slick";
import { ApiService } from "@/app/services/AppService";
import { getHubId } from "../genericComponents/helper-functions/currencyCode";
import { BannerMobile, ResponseObject } from "@/app/classes/main";
import { useRouter } from "next/navigation";
import { Loader } from "../genericComponents/MainLoader/Loader";
import "./navbarMobileBanners.css";
import ScannerAuth from "../genericComponents/scanner-auth/ScannerAuth";
import { IconButton } from "@mui/material";
import PlayArrowIcon from "@mui/icons-material/PlayArrow";
import PauseIcon from "@mui/icons-material/Pause";
import VolumeOffIcon from "@mui/icons-material/VolumeOff";
import VolumeUpIcon from "@mui/icons-material/VolumeUp";
interface NavbarMobileBannersProps {
  setReloadScrollFlag: (flag: boolean) => void;
  setReloadSearchPositionFlag: (flag: boolean) => void;
  reloadNavBackground: any;
  visible: any;
}

interface SubCategory {
  id: number;
  slug: string; // Add all other fields that are relevant
}

interface Categories {
  id: number;
  slug: string; // Add all other fields that are relevant
}

export const NavbarMobileBanners: React.FC<NavbarMobileBannersProps> = ({
  setReloadScrollFlag,
  setReloadSearchPositionFlag,
  reloadNavBackground,
  visible,
}) => {
  const [banner, setBanner] = useState<BannerMobile[]>([]);
  const [categories, setCategories] = useState<Categories[]>([]);
  const [subcategories, setSubcategories] = useState<SubCategory[] | null>(
    null
  );
  const [opacity, setOpacity] = useState(1);
  const [loader, setLoader] = useState(false);
  const [serviceHubSlug, setServiceHubSlug] = useState("noida");
  const [openInfo, setOpenInfo] = useState(false);
  const [slug, setSlug] = useState<undefined | string | null>(null);
  const [bannerId, setBannerId] = useState<undefined | number>();
  const [isPlaying, setIsPlaying] = useState(true);
  const [isMuted, setIsMuted] = useState(true);
  const xHubId = getHubId();
  const router = useRouter();
  const apiService = useMemo(() => new ApiService(), []);
  const videoRef = useRef<HTMLVideoElement | null>(null);

  const settings = useMemo(
    () => ({
      dots: true,
      infinite: true,
      // autoplay: true,
      // autoplaySpeed: 10000,
      arrows: false,
      speed: 1000,
      slidesToShow: 1,
      slidesToScroll: 1,
      className: "myCustomCarouselBannerMobileView",
    }),
    []
  );

  useEffect(() => {
    try {
      const storedSlug = localStorage.getItem("serviceHubSlug");
      if (storedSlug) {
        const decodedSlug = JSON.parse(atob(storedSlug));
        if (decodedSlug) {
          setServiceHubSlug(decodedSlug || "noida");
        }
      }
    } catch (error) {
      console.error("Error decoding or parsing serviceHubSlug:", error);
    }
  }, []);

  const getDataMobileBanners = useMemo(
    () => async () => {
      try {
        const responseObject: ResponseObject | undefined =
          await apiService.get<ResponseObject>(
            apiService.headerBannerMobile + "?hubId=" + xHubId
          );
        const categories: ResponseObject | undefined = (
          await apiService.get<any>(
            apiService.categories + "?hubSlug=" + serviceHubSlug
          )
        ).object;
        const response: ResponseObject | undefined = await apiService.get<any>(
          `${apiService.subcategories}?hubSlug=${serviceHubSlug}&categorySlug=salon-at-home`
        );
        setSubcategories(response?.object || []);
        setCategories(categories?.object || []);
        setBanner(responseObject?.object || []);
      } catch (error) {
        console.log("Error fetching data:", error);
      }
    },
    [apiService, xHubId, serviceHubSlug]
  );

  useEffect(() => {
    getDataMobileBanners();
  }, [getDataMobileBanners]);

  const updatedBannersArray = useMemo(
    () =>
      banner?.map((item: any) => {
        const matchedCategory = categories?.find(
          (category: any) => category.id === item.categoryId
        );

        const matchedSubCategory = subcategories?.find(
          (subCategory: any) => subCategory.id === item.subCategoryId
        );

        return {
          ...item,
          slug: matchedCategory ? matchedCategory?.slug : "salon-at-home",
          subSlug: matchedSubCategory ? matchedSubCategory?.slug : null,
        };
      }),
    [banner, categories, subcategories]
  );

  useEffect(() => {
    const initialScrollY = window.scrollY;
    const initialOpacity = Math.max(0.1, 1 - initialScrollY / 200);
    const initialOpacityValue = parseFloat(initialOpacity.toFixed(1));
    setOpacity(initialOpacityValue);
    if (initialOpacityValue <= 0.9) {
      setReloadSearchPositionFlag(true);
    }
    const handleScroll = () => {
      const scrollY = window.scrollY;
      const newOpacity = Math.max(0.1, 1 - scrollY / 200);
      const roundedOpacity = parseFloat(newOpacity.toFixed(1));
      setOpacity((prevOpacity) =>
        prevOpacity !== roundedOpacity ? roundedOpacity : prevOpacity
      );

      if (roundedOpacity <= 0.6) {
        setReloadScrollFlag(true);
      } else if (roundedOpacity <= 0.9) {
        setReloadSearchPositionFlag(true);
      } else {
        setReloadScrollFlag(false);
        setReloadSearchPositionFlag(false);
      }
      reloadNavBackground(roundedOpacity);
    };
    window.addEventListener("scroll", handleScroll);
    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, [setReloadScrollFlag, setReloadSearchPositionFlag, reloadNavBackground]);

  useEffect(() => {
    if (opacity < 0.7 && videoRef.current) {
      videoRef.current.pause();
      // videoRef.current.muted = true;
      setIsPlaying(false);
      setIsMuted(true);
    }
  }, [opacity]);

  const handleMobileImage = (item: any) => {
    const { slug, subSlug, bannerTypeCode, pageContentId } = item;
    if (bannerTypeCode == 5) {
      setOpenInfo(true);
      setBannerId(pageContentId);
      setSlug(slug);
    } else {
      setLoader(true);
      subSlug
        ? router.push(`${serviceHubSlug}/${slug}/${subSlug}`)
        : router.push(`${serviceHubSlug}/${slug}`);
    }
  };

  // const handlePlayPause = (
  //   e: React.MouseEvent<HTMLButtonElement, MouseEvent>
  // ) => {
  //   e.preventDefault();
  //   e.stopPropagation();

  //   if (videoRef.current) {
  //     if (isPlaying) {
  //       videoRef.current.pause();
  //       setIsPlaying(false);
  //     } else {
  //       videoRef.current
  //         .play()
  //         .then(() => {
  //           setIsPlaying(true);
  //         })
  //         .catch((error) => {
  //           console.log("Error while playing the video:", error);
  //         });
  //     }
  //   }
  // };

  const handleMuteUnmute = (
    e: React.MouseEvent<HTMLButtonElement, MouseEvent>
  ) => {
    e.preventDefault();
    e.stopPropagation();
    if (videoRef.current) {
      if (videoRef.current.muted) {
        videoRef.current.muted = false;
        setIsMuted(false);
      } else {
        videoRef.current.muted = true;
        setIsMuted(true);
      }
    }
  };

  return (
    <>
      <div
        style={{
          position: opacity < 0.7 ? "fixed" : "absolute",
          top: !visible ? 0 : opacity < 0.7 ? 0 : 65,
          left: 0,
          width: "100%",
        }}
      >
        <Slider {...settings}>
          {updatedBannersArray &&
            updatedBannersArray.map((banner, index) => (
              <div key={index}>
                <div
                  style={{
                    position: "relative",
                    width: "100%",
                    height: "18rem",
                    overflow: "hidden",
                  }}
                  onClick={() => handleMobileImage(banner)}
                >
                  {/* Check if the banner contains a video */}
                  {banner?.mobileImage?.secureHttpPath?.endsWith(".mp4") ||
                  banner?.mobileImage?.secureHttpPath?.endsWith(".webm") ? (
                    <>
                      <video
                        ref={videoRef}
                        style={{
                          width: "100%",
                          height: "18rem",
                          objectFit: "fill",
                          borderRadius: "0px 0px 1rem 1rem",
                          opacity: opacity,
                        }}
                        autoPlay
                        loop
                        muted={isMuted}
                        playsInline
                        onContextMenu={(e) => e.preventDefault()}
                        disablePictureInPicture
                        controlsList="nodownload noremoteplayback noplaybackrate"
                        controls={false} // Disable video controls
                        preload="auto"
                      >
                        <source
                          src={banner?.mobileImage?.secureHttpPath}
                          type="video/mp4"
                        />
                        Your browser does not support the video tag.
                      </video>
                      <div
                        style={{
                          position: "absolute",
                          bottom: "70px",
                          right: "15px",
                          zIndex: 10,
                          display: "flex",
                          flexDirection: "row",
                        }}
                      >
                        {/* <IconButton
                          onClick={handlePlayPause}
                          style={{
                            background: "#fff",
                            color: "#000",
                            border: "none",
                            padding: "6px",
                            borderRadius: "50%",
                          }}
                        >
                          {isPlaying ? <PauseIcon /> : <PlayArrowIcon />}
                        </IconButton>
                        &nbsp; &nbsp; */}
                        <IconButton
                          onClick={handleMuteUnmute}
                          style={{
                            background: "#fff",
                            color: "#000",
                            border: "none",
                            padding: "6px",
                            borderRadius: "50%",
                          }}
                        >
                          {isMuted ? <VolumeOffIcon /> : <VolumeUpIcon />}
                        </IconButton>
                      </div>
                    </>
                  ) : (
                    // Parallax for images
                    <Parallax
                      bgImage={banner?.mobileImage?.secureHttpPath}
                      strength={100}
                      bgImageStyle={{
                        opacity: opacity,
                        objectFit: "cover",
                        height: "18rem",
                        width: "100%",
                      }}
                    >
                      <div style={{ height: "18rem" }} />
                    </Parallax>
                  )}
                </div>
              </div>
            ))}
        </Slider>
      </div>
      {loader && <Loader />}
      <ScannerAuth
        openInfo={openInfo}
        handleClose={() => setOpenInfo(false)}
        id={bannerId}
        slug={slug}
        serviceHubSlug={serviceHubSlug}
      />
    </>
  );
};

export default NavbarMobileBanners;
